import React from 'react';
import { Container, Typography, Box, TextField } from '@mui/material';
import { useNavigate, useOutletContext } from 'react-router-dom';
import PropertyFooterLayout from '../../../components/properties/PropertyFooterLayout';
import { useAuth } from '../../../context/AuthContext';

const progress = 60; 
const step = 2; 

type PublishOutletContext = {
  handleNavigateToPropertyVisibility: () => void;
  handleNavigateToPropertyAssignee: () => void;
  propertyDescription: string;
  setPropertyDescription: (propertyDescription: string) => void;
};

const PropertyDescriptionPage: React.FC = () => {
  const navigate = useNavigate();
  const { handleNavigateToPropertyVisibility, propertyDescription, setPropertyDescription, handleNavigateToPropertyAssignee } = useOutletContext<PublishOutletContext>();
  const { userToken} = useAuth();
  
  const handleBack = () => {
    navigate(-1);
  };

const handleContinue = () => {
  setPropertyDescription(propertyDescription);
  
  const realtorProfile = userToken?.user.profiles.find(profile => profile.roleId === 3);
  const isLeader = realtorProfile?.realtor?.isLeader;
  
  if (isLeader) {
    handleNavigateToPropertyAssignee();
  } else {
    handleNavigateToPropertyVisibility();
  }
};

  const charCount = propertyDescription.length;
  const maxLength = 5000; 

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newDescription = e.target.value;
    if (newDescription.length <= maxLength) {
      setPropertyDescription(newDescription);
    }
  };

  return (
    <Container maxWidth="md" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Box mt={4} p={4} sx={{ width: '100%' }}>
        <Box sx={{ maxWidth: '600px', mx: 'auto', width: '100%' }}>
          <Typography variant="h4" gutterBottom>
            Ahora, describe tu propiedad
          </Typography>
          <Typography variant="body1" mb={4}>
            Proporciónanos una descripción detallada de tu propiedad. Esto ayudará a los posibles interesados a conocer más sobre ella.
          </Typography>

          <TextField
            label="Descripción de la propiedad"
            variant="outlined"
            fullWidth
            multiline
            rows={8} 
            value={propertyDescription}
            onChange={handleChange}
            sx={{
              mb: 2,
              borderRadius: 2,
              '&:hover .MuiOutlinedInput-root': {
                border: '2px solid black',
              },
              '& .MuiOutlinedInput-root': {
                border: '2px solid grey',
                '&.Mui-focused fieldset': {
                  border: '2px solid black',
                },
              },
              '& .MuiInputLabel-root': {
                color: 'grey',
                '&.Mui-focused': {
                  color: 'green',
                },
              },
            }}
          />
          <Typography variant="button" color="textSecondary" textAlign="right">
            {charCount}/{maxLength}
          </Typography>
        </Box>

        <PropertyFooterLayout
          progress={progress}
          step={step}
          onBack={handleBack}
          onContinue={handleContinue}
          isContinueDisabled={propertyDescription.trim().length === 0}
        />
      </Box>
        <Box
          sx={{
            height: "50px",
            display: { xs: "block", sm: "none" },
            width: "100%",
          }}
        />
    </Container>
  );
};

export default PropertyDescriptionPage;
